if($('#install-pwa .switcher').length > 0) {
    $('#install-pwa .switcher .item').click(function () {
        $('#install-pwa .switcher .item').removeClass('active');
        $(this).addClass('active');

        $('#install-pwa .info').addClass('hide');
        $('#' + $(this).attr('data-key')).removeClass('hide');
    });
}